<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "payments",
    cardSetLink: "payments",
    item: null,
    fields: [
      {
        key: "title",
        label: "Название",
        isMultiLang: true,
        type: 'field',
      },
      {
        key: "description",
        label: "Краткое описание",
        isMultiLang: true,
        type: 'textarea',
      },
      {
        key: "price_fix",
        label: "Стоимость за 1 транзакцию",
        type: "field",
        textType: "number",
      },
      {
        key: "price_percent",
        label: "Процест транзакции",
        type: "field",
        textType: "number",
      },
      {
        col:'col-5',
        key: "logo",
        label: "Логотип",
        type: "img",
      },
      {
        key: "is_active",
        label: "Период (месяцев)",
        type: "checkbox",
      },
      {
        key: "is_online",
        label: "Онлайн оплата",
        type: "checkbox",
      },
      {
        key: "code",
        label: "Код",
        type: "field",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>

</style>
